import { supabase } from '../../lib/supabase'

export type ReminderParams = { teamId: string; periodStart: string; version: number }

// How many agents are still waiting on the version, and how many were sent a
// reminder now (an agent already reminded today is not sent another).
export type ReminderResult = { ok: true; waiting: number; reminded: number } | { ok: false; message: string }

// Asks v1-remind-schedule-acknowledgements to remind the agents who have not
// acknowledged a published version. A refusal carries its reason (a newer
// version has replaced this one), which the supervisor reads rather than a
// generic failure.
export async function remindUnacknowledged(params: ReminderParams): Promise<ReminderResult> {
  const { data, error } = await supabase.functions.invoke('v1-remind-schedule-acknowledgements', { body: params })
  if (!error) return { ok: true, waiting: Number(data?.waiting ?? 0), reminded: Number(data?.reminded ?? 0) }

  let message = error.message
  const context = (error as { context?: { json?: () => Promise<{ error?: string }> } }).context
  if (context?.json) {
    try {
      const body = await context.json()
      if (body.error) message = body.error
    } catch {
      // The body was not JSON; the error's own message stands.
    }
  }
  return { ok: false, message: message || 'The reminders could not be sent.' }
}
